import { useState, useCallback } from "react";
import { executeWorkflowHandshake } from "../../components/Workflow-esg/Workflow_XLS_Support";

export default function DefinitionsOrchestrationController(userId) {
  const [searchTerm, setSearchTerm] = useState("Oil"); // 🎯 Defaulting to 'Oil' for your test
  const [isSearching, setIsSearching] = useState(false);
  const [disclosure_results, setDisclosureResults] = useState(null);
  
  const [selectedElements, setSelectedElements] = useState({});
  const [activeElementId, setActiveElementId] = useState(null);

  // 🎯 FIXED: Using the verified working path prefix
  const S3_BUCKET = "esg-template-management";
  const S3_KEY = "ESG_Taxonomy_Sync_1774775834716/BaseStructure/ESG_Taxonomy_Sync_1774775834716.json";

  const executeDisclosureSearch = useCallback(async () => {
    if (!searchTerm || searchTerm.trim().length < 2) return;

    setDisclosureResults(null);
    setIsSearching(true);

    // 🎯 PAYLOAD ALIGNED TO WORKING METRICS
    const payload = {
      action: "SEARCH_DISCLOSURES",
      user_id: userId, 
      payload: {
        bucketName: S3_BUCKET,
        fileName: S3_KEY,
        searchQuery: searchTerm.trim()
      }
    };

    try {
      const response = await executeWorkflowHandshake(
        "doorman/disclosures",
        payload,
        "Disclosures"
      );

      // 🎯 Ensuring the UI waits for response.data.data
      if (response?.success && response?.data?.data) {
        setDisclosureResults(response.data.data);
      }
    } catch (err) {
      console.error("🚨 [AWS_FETCH_ERROR]:", err.message);
    } finally {
      setIsSearching(false);
    }
  }, [userId, searchTerm]);

  const addElement = (item) => {
    setSelectedElements(prev => ({
      ...prev,
      [item.naceId]: { ...item, assets: [], isDefined: false }
    }));
    setActiveElementId(item.naceId);
  };

  const removeElement = (id) => {
    setSelectedElements(prev => {
      const updated = { ...prev };
      delete updated[id];
      return updated;
    });
    if (activeElementId === id) setActiveElementId(null);
  };

  return {
    searchTerm,
    setSearchTerm,
    isSearching,
    disclosure_results,
    executeDisclosureSearch,
    selectedElements,
    activeElementId,
    setActiveElementId,
    addElement,
    removeElement
  };
}